import type { SVGProps } from "react";
// generated from Scale.svg — do not edit manually
// prettier-ignore
export default function Scale(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 3 21 V 3 H 21 V 21 H 3 Z M 3 21 V 12 H 12 V 21 H 3 Z" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
